import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../utils/base-query';
import { errorObjectToStringTransformer } from '../user/user.toolkit-error-transformers';
import { accountQuery } from '../account/account.toolkit-api';
import { requestPaidPlanQuery, startTrial } from './account-plan.toolkit-queries';
import { REDUCER_PATH } from './account-plan.consts';

export const accountPlanQuery = createApi({
  reducerPath: REDUCER_PATH,
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    startTrial: builder.mutation<void, void>({
      query: startTrial,
    }),
    requestPaidPlan: builder.mutation<void, string>({
      query: requestPaidPlanQuery,
      transformErrorResponse: errorObjectToStringTransformer,
      async onQueryStarted(accountId, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          accountQuery.util.updateQueryData('getAccountById', accountId, (draft) => {
            Object.assign(draft, { paidPlanRequested: true });
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});
